/** Display text lives in the `home` / `common` translation files; these are keys. */
export interface NavLink {
  labelKey: string;
  href: string;
}

export const navLinks: NavLink[] = [
  { labelKey: "common.nav.howItWorks", href: "#how-it-works" },
  { labelKey: "common.nav.demo", href: "#demo" },
  { labelKey: "common.nav.pricing", href: "#pricing" },
  { labelKey: "common.nav.faq", href: "#faq" },
  { labelKey: "common.nav.contact", href: "#contact" },
];

export interface Step {
  icon: string;
  titleKey: string;
  descriptionKey: string;
}

export const steps: Step[] = [
  {
    icon: "ri-quill-pen-line",
    titleKey: "home.howItWorks.steps.upload.title",
    descriptionKey: "home.howItWorks.steps.upload.description",
  },
  {
    icon: "ri-magic-line",
    titleKey: "home.howItWorks.steps.generate.title",
    descriptionKey: "home.howItWorks.steps.generate.description",
  },
  {
    icon: "ri-download-cloud-2-line",
    titleKey: "home.howItWorks.steps.download.title",
    descriptionKey: "home.howItWorks.steps.download.description",
  },
];

export interface FaqItem {
  questionKey: string;
  answerKey: string;
}

export const faqItems: FaqItem[] = ["howItWorks", "formats", "freePoints", "payments", "security", "refunds"].map((id) => ({
  questionKey: `home.faq.items.${id}.question`,
  answerKey: `home.faq.items.${id}.answer`,
}));
